export const reactSelectDefaultStyles = {
    menu: (s: any) => ({ ...s, zIndex: 999, marginTop: '5px' }),
    menuPortal: (s: any) => ({ ...s, zIndex: 9999 }),
    control: (s: any) => ({ ...s, borderRadius: '2px', height: '3em', borderColor: '#ddd' }),
    menuList: (styles: any) => ({ ...styles, zIndex: 999 }),
};
